export default '/static/frontend/ReachDigital/12gobiking/dist/assets/riverty-c1b57175.svg'